// Header da V3: fixo ao rolar (CSS sticky no wrapper .ds-header-section). Ao DESCER passa pro modo
// compacto (esconde a faixa do seletor no desktop e a linha do veículo no celular); ao SUBIR mostra
// de novo. Mantém --header-height atualizado (o Dawn usa na busca preditiva).
const header = document.querySelector("[data-ds-header]");
if (header) {
  const secao = header.closest(".shopify-section") ?? header;
  const LIMIAR = 120;
  let ultimoY = window.scrollY;
  let agendado = false;

  const medir = () => document.documentElement.style.setProperty("--header-height", `${secao.offsetHeight}px`);

  const aoRolar = () => {
    agendado = false;
    const y = window.scrollY;
    if (Math.abs(y - ultimoY) < 8) return;
    const algoAberto = header.querySelector("details[open]");
    if (y > ultimoY && y > LIMIAR && !algoAberto) header.setAttribute("data-compacto", "");
    else if (y < ultimoY) header.removeAttribute("data-compacto");
    ultimoY = y;
  };

  window.addEventListener(
    "scroll",
    () => {
      if (agendado) return;
      agendado = true;
      requestAnimationFrame(aoRolar);
    },
    { passive: true }
  );
  // foco pelo teclado dentro do header (ex.: Tab até a faixa): volta ao normal
  header.addEventListener("focusin", () => header.removeAttribute("data-compacto"));
  new ResizeObserver(medir).observe(secao);
  medir();
}
